import type { ReactNode } from 'react';
import { Children, Fragment, cloneElement, isValidElement } from 'react';

export function iconWithProps(icon: ReactNode, label?: string) {
  return Children.map(icon, (child) => {
    if (isValidElement(child) && child.type !== Fragment) {
      const altText = child.props.altText || label;
      const color = child.props.color || 'inherit';
      return cloneElement(child, {
        altText,
        color,
      });
    }
    return child;
  });
}
